import { BadPressMatchResolution } from 'app/entities/monitoring/actual/badpress-match.model';
import { SanctionMatchResolution } from 'app/entities/monitoring/actual/sanction-matches.model';

/**
 * Model to capture (Client) Organisation.
 */
export class Organisation {
    id: number;
    entityId: number;
    name: string;
    isin: string;
    logo: string;
    legalStructureId: number;
    legalStructureName: string;
    stockExchangeId: number;
    stockExchangeName: string;
    incorporatedDate: Date | string | null;
    registrationCode: string;
    sanctionStatus = SanctionMatchResolution.FALSE;
    badPressStatus = BadPressMatchResolution.FALSE;
    isSpecialFinancialInstitution: boolean;
    clientId: number;
    userId: number;
    bankAccounts: Array<String>;
    addresses: Array<Object>;
    // client specific
    startOfService: Date | string | null;
    endOfService: Date | string | null;
    accountManagerId: number;
    accountManagerName: string;
    financeManagerId: number;
    financeManagerName: string;
    isWTT: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/organisation.model.ts